<template>
  <div :class="row ? 'search-row' : 'search'" :style="{ width: width }">
    <SearchBox :labeltxt="labeltxt" :row="row">
      <v-text-field
        :type="type"
        :height="height"
        hide-details="auto"
        outlined
        rounded
        dense
        :value="value"
        @input="(value) => $emit('input', value)"
        @keyup.enter="doKeyUp"
        @blur="doOnBlur"
        @focus="doOnFocus"
        :placeholder="placeholder"
        :error-messages="errorMessages"
        :key="componentKey"
        :clearable="clearable"
        :labeltxt="labeltxt"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="max"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
      >
      </v-text-field>
    </SearchBox>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    type: {
      type: [String],
    },
    value: {
      type: [String, Number],
    },
    placeholder: {
      type: [String],
    },
    height: {
      type: [Number, String],
      default() {
        return 32;
      },
    },
    labeltxt: {
      type: [String],
      default() {
        return null;
      },
    },
    errorMessages: {
      type: [String, Array],
    },
    componentKey: {
      type: [Number, String],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    max: {
      type: [String, Number],
      default() {
        return 524288;
      },
    },
  },
  methods: {
    doKeyUp() {
      this.$emit('keyup');
    },
    doOnBlur() {
      this.$emit('doOnBlur');
    },
    doOnFocus() {
      this.$emit('doOnFocus');
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  width: 160px;
  display: inline-block;
}

.search-row {
  width: 320px;
  display: inline-block;
}

::v-deep.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 0.5rem;
  .v-input__append-inner {
    margin-top: 0 !important;
    height: 100%;
    display: flex;
    align-items: center;
  }

  ::-webkit-input-placeholder {
    text-align: flex-start;
    padding-left: 4px;
  }
}

/* 去除number input arrows */
/* Chrome, Safari, Edge, Opera */
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>
